module.exports = __webpack_public_path__ + "static/media/tlyfe-logo.6ef5fe38.png";